// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.resizeBar[data-v-84b886fe]\n\t{\n\t\tposition: absolute;\n/*\t\tbackground-color: rgba(255,0,0,0.25);*/\n\t\tuser-select: none;\n\t\tz-index: 100;\n}\n.resizeBar.vertical[data-v-84b886fe]\n\t\t{\n\t\t\theight: 100%;\n\t\t\twidth: 9px;\n\t\t\ttop: 0px;\n\t\t\tcursor: ew-resize;\n}\n.resizeBar.horizontal[data-v-84b886fe]\n\t\t{\n\t\t\twidth: 100%;\n\t\t\theight: 9px;\n\t\t\tleft: 0px;\n\t\t\tcursor: ns-resize;\n}\n", ""]);
// Exports
module.exports = exports;
